import css from 'styled-jsx/css';

export default css`.favoriteButton {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 8px 0;
  position: absolute; }
  .favoriteButton .icon {
    display: inline-block;
    position: relative;
    margin-right: 20px; }
    .favoriteButton .icon :global(.iconStarO) {
      font-size: 16px;
      position: absolute;
      color: #444; }
    .favoriteButton .icon :global(.iconStar) {
      font-size: 16px;
      position: absolute;
      color: #f9d66d; }
    .favoriteButton .icon :global(.lottieStar) {
      position: absolute;
      width: 51px;
      height: 51px;
      margin-top: -1px; }
  .favoriteButton .favoriteButton__text {
    color: #666;
    margin: 0 2px; }
  .favoriteButton .favoriteButton__num {
    color: #666;
    margin: 0 2px; }
    .favoriteButton .favoriteButton__num.favoriteButton__num--nodata {
      padding: 0 4px; }
  .favoriteButton :global(.topListDrawerPaper) {
    overflow-y: visible; }
`